var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step4" }, [
    _c("div", { staticClass: "step4__content" }, [
      _c("p", { staticClass: "step4__header" }, [
        _vm._v("Please verify the information below is correct."),
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "step4__subheader" },
        [
          _c("IconMapMarker", { attrs: { color: "#00BAF2" } }),
          _vm._v(" "),
          _c("span", [_vm._v("Appointment Location")]),
          _vm._v(" "),
          _c("strong", [_vm._v(_vm._s(_vm.displayClinicAddress))]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "step4__details" }, [
        _c(
          "div",
          { staticClass: "step4__item" },
          [
            _c("IconCheck", { attrs: { color: "#00BAF2" } }),
            _vm._v(" "),
            _c("div", { staticClass: "step4__item-content" }, [
              _c("p", { staticClass: "step4__item-title" }, [
                _vm._v("Appointment Type"),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "step4__item-value" }, [
                _vm._v(_vm._s(_vm.displayAppointmentType[0])),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "step4__item-value" }, [
                _vm._v(_vm._s(_vm.displayAppointmentType[1])),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "step4__item" },
          [
            _c("IconCalendar", { attrs: { color: "#00BAF2" } }),
            _vm._v(" "),
            _c("div", { staticClass: "step4__item-content" }, [
              _c("p", { staticClass: "step4__item-title" }, [
                _vm._v("Appointment Date"),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "step4__item-value" }, [
                _vm._v(_vm._s(_vm.displayAppointmentDate)),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "step4__item" },
          [
            _c("IconPerson", { attrs: { color: "#00BAF2" } }),
            _vm._v(" "),
            _c("div", { staticClass: "step4__item-content" }, [
              _c("p", { staticClass: "step4__item-title" }, [
                _vm._v("Patient Name"),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "step4__item-value" }, [
                _vm._v(
                  _vm._s(_vm.patient.firstName) +
                    " " +
                    _vm._s(_vm.patient.lastName)
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "step4__item" },
          [
            _c("IconClock", { attrs: { color: "#00BAF2" } }),
            _vm._v(" "),
            _c("div", { staticClass: "step4__item-content" }, [
              _c("p", { staticClass: "step4__item-title" }, [
                _vm._v("Appointment Time"),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "step4__item-value" }, [
                _vm._v(_vm._s(_vm.displayAppointmentTime)),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "step4__item" },
          [
            _c("IconPhone", { attrs: { color: "#00BAF2" } }),
            _vm._v(" "),
            _c("div", { staticClass: "step4__item-content" }, [
              _c("p", { staticClass: "step4__item-title" }, [
                _vm._v("Patient Phone"),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "step4__item-value" }, [
                _vm._v(_vm._s(_vm.patient.phoneNumber)),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "step4__item" },
          [
            _c("IconEnvelope", { attrs: { color: "#00BAF2" } }),
            _vm._v(" "),
            _c("div", { staticClass: "step4__item-content" }, [
              _c("p", { staticClass: "step4__item-title" }, [
                _vm._v("Patient Email"),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "step4__item-value" }, [
                _vm._v(_vm._s(_vm.patient.emailAddress)),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("fieldset", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.emailAddressVerify,
                expression: "form.emailAddressVerify",
              },
            ],
            staticClass: "emailAddressVerify",
            attrs: {
              placeholder: "Verify Email Address*",
              type: "email",
              tabindex: "3",
              required: "",
            },
            domProps: { value: _vm.form.emailAddressVerify },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "emailAddressVerify", $event.target.value)
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "step4__footer" }, [
      _c(
        "button",
        {
          staticClass: "btn-beltone xl",
          class: { disabled: _vm.submitting },
          on: {
            click: function ($event) {
              return _vm.prevStep()
            },
          },
        },
        [_vm._v("Back")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-beltone xl",
          class: { disabled: _vm.submitting },
          on: {
            click: function ($event) {
              return _vm.complete()
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.submitting,
                  expression: "submitting",
                },
              ],
              staticClass: "btn-spinner",
            },
            [_vm._m(0)]
          ),
          _vm._v(" "),
          _c("span", { class: { hidden: _vm.submitting } }, [
            _vm._v("Schedule"),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "outer" }, [
      _c("div", { staticClass: "inner" }, [_c("span")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }